import {Component, OnInit, ViewChild} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {LocalStorageService} from 'ng2-webstorage';
import * as html2pdf from "html2pdf.js";
import {StudentDataService} from '../../../../service/student-data.service';
import {MessageService} from 'primeng/components/common/messageservice';
import {ConfirmationService, Paginator} from 'primeng/primeng';
import {addParentChildModel} from '../../../../../components/parentchild/addparent/addparentchild.model';
import {NoticeboardService} from '../../../../../components/noticeboard/noticeboard/noticeboard.service';
import {ParentChildService} from '../../../../../components/parentchild/parentchild.service';
import {DataAnalyticsService} from '../../../../../components/dataAnalytics/dataAnalytics.service';
import {DepartmentService} from '../../../../../components/manageuser/department/department.service';
import {addDepartmentModel} from '../../../../../components/manageuser/department/addDepartment.model';

@Component({
  selector: 'app-student-profile',
  templateUrl: './manage-user-department.component.html',
  styleUrls: ['./manage-user-department.component.css']
})

export class ManageUserDepartmentComponent implements OnInit {

  public addDepartmentmodel = new addDepartmentModel();
  public schoolId: any;
  public department: any;
  // display: boolean = false;
  display = "none"
  public maxSize: number = 10;
  public bigTotalItems: number;
  public bigCurrentPage: number = 1;
  public numPages: number = 0;
  public searchString: string;
  public spinnershow: boolean = false;
  public rolesList: any;
  public departmentList: any;
  public info:boolean=false;
  public isList:boolean=true;
  constructor(private departmentService: DepartmentService, private messageService: MessageService, private confirmationService: ConfirmationService, private localStorage: LocalStorageService) {
    this.schoolId = this.localStorage.retrieve('SchoolId');

  }
  ngOnInit() {
    this.GetRolesList();
    this.GetDepartment(this.bigCurrentPage);
  }
  //roleslist
  public GetRolesList() {
    this.spinnershow = true;
    this.departmentService.getSbaccessRoles().finally(() => { }).subscribe(
      response => {
        this.rolesList = response;
        console.log('roles',this.rolesList)
      }
    )
  }
  onSearchChange(searchString) {
    this.searchString = searchString;
    this.GetDepartment(this.bigCurrentPage);
  }

  // new post Department
  public postDepartment() {
    this.addDepartmentmodel.SchoolId=this.schoolId;
    this.departmentService.postDepartment(this.addDepartmentmodel).finally(() => { }).subscribe(
      response => {
        this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: 'Category/Department Added Successfully' });
        // this.display = false;
        this.display = "none";
        this.GetDepartment(this.bigCurrentPage);
      },
      error => { }
    );
  }
  confirm(categoryId) {
    this.confirmationService.confirm({
      message: 'Are you sure that you want to perform this action?',
      accept: () => {
        this.eraseDepartment(categoryId);
      }
    });
  }
  public GetDepartment(pagenum) {
    this.spinnershow = true;
    this.departmentService.GetCategory(pagenum, this.searchString,this.isList).finally(() => { this.spinnershow = false }).subscribe(
      response => {
        console.log('res',response)
        this.bigTotalItems = (Number(response['TotalPages']) * this.maxSize);
        this.departmentList = response['items'];
      }
    )
  }
  public eraseDepartment(categoryId) {
    this.departmentService.DeleteDepartment(categoryId).finally(() => { }).subscribe(
      response => {
        var value = response['Value'];
        if (value == 'Already in use!') {
          this.messageService.add({ severity: 'error', summary: 'Talkative Parents', detail: value });
        } else
        if (value == 'Deleted Successfully!') {
          this.messageService.add({ severity: 'success', summary: 'Talkative Parents', detail: value });
        }
        // this.display = false;
        this.GetDepartment(this.bigCurrentPage);
      }
    )
  }
  changeSort(event) {
  }
  addCategory() {
    this.addDepartmentmodel = new addDepartmentModel();
    this.display= "block"
    // this.display = true;
  }

  onCloseHandled() {
    this.display= "none";
  }

  // editCategory(Dept) {
  //   this.addDepartmentmodel = new addDepartmentModel();
  //   this.addDepartmentmodel['Schoolid'] = this.schoolId;
  //   var selObj = Object.assign({}, Dept);
  //   this.addDepartmentmodel['categoryid'] = selObj.Id;
  //   this.addDepartmentmodel['Name'] = selObj.Name;
  //   this.addDepartmentmodel['Responsestatus'] = selObj.Responsestatus;
  //   this.display = true;
  // }
  editCategory(dept){
    this.departmentList.filter(ele=>{
      if(ele.Id==dept.Id){
        this.addDepartmentmodel.Name=dept.Name;
        this.addDepartmentmodel.Id=dept.Id;
        this.addDepartmentmodel.SBAccessRankId=Number(dept.SbAccessRankId);
        // this.display = true;
        this.display = "block";
      }
    })
  }
  pageChanged(event) {
    this.GetDepartment(event.page);
  }
  roleinfo(){
    this.info=true;
  }

}



// WEBPACK FOOTER //
// /builds/yaratechnologies/talkative-parents-portal/src/app/parent/dashboard/pages/manage-user/manage-user-department/manage-user-department.component.ts